export const TRANSFER_MODE = {
  STATIC: 'Static',
  DYNAMIC: 'Dynamic',
} as const;

export type TransferMode = (typeof TRANSFER_MODE)[keyof typeof TRANSFER_MODE];

export type TransferConfiguration = {
  agent_id: number;
  /** Static mode: E.164 destination number. Dynamic mode: routing instructions. */
  prompt: string;
  transfer_mode: TransferMode;
  enabled: boolean;
  max_attempts: number | null;
};

export type TransferConfigurationUpdateRequest = {
  prompt: string;
  transfer_mode: TransferMode;
  enabled: boolean;
  max_attempts: number | null;
};
